import React, {ReactElement} from "react";

export function InputControl(props: { default: number, label: string }): ReactElement {
    return <></>;
}
